/* eslint-disable max-len */
import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';
import UpdateModal from '../components/UpdateModal';

function BasicAmountContainer({ getSettingList, settingList }) {
  const setModal = useContext(ModalContext);

  const handleEdit = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Cedula Settings - Individual',
      modalSize: 'modal-md',
    });
  };

  useEffect(() => {
    getSettingList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  return (
    <div className="card p-0">
      <div className="container-fluid">
        <div className="d-flex align-items-center p-4">
          <h3 className="mb-0">Basic Amount - Birth Certificate</h3>
        </div>
        <hr />
        <div className="row">
          <div className="col-12 py-3">
            <div className="w-100">
              <table className="w-100">
                <thead>
                  <tr>
                    <td className="pl-6">Basic Amount</td>

                    <td className="pr-6" />
                  </tr>
                </thead>
                <tbody>
                  {settingList.map(item => (
                    <tr key={item.id} className="top-border">
                      <td className="td-item pl-6">
                        {_.get(item, 'attributes.city_municipal') || '--'}
                      </td>
                      <td className="pr-6">
                        <div className="d-flex">
                          <button
                            type="button"
                            className="btn-blank ml-auto"
                            onClick={handleEdit(item)}
                          >
                            <i className="far fa-edit icon-edit" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

BasicAmountContainer.propTypes = {
  getSettingList: PropTypes.instanceOf(Function).isRequired,
  settingList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  settingList: _.get(api, `${c.GET_SETTING}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BasicAmountContainer);
